export const FILTER_Y7 = 'Y7'
export const FILTER_Y12 = 'Y12'
export const FILTER_Y16 = 'Y16'
export const FILTER_Y18 = 'Y18'
